import { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/home/Home";
import NotFound from "./pages/NotFound";
import About from "./pages/about/About";
import Contact from "./pages/contact/Contact";
import HireSkills from "./pages/hire/HireSkills";
import HireCountry from "./pages/hire/HireCountry";
import HireServices from "./pages/hire/HireServices";
import EmployerSignUp from "./pages/employer/EmployerSignUp";
import EmployerDetailsRequest from "./pages/employer/EmployerDetailsRequest";
import DeveloperSignUp from "./pages/developer/DeveloperSignup";
import DeveloperDetailsRequest from "./pages/developer/DeveloperDetails";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Terms from "./pages/Terms";
import Policy from "./pages/Policy";
import DeveloperDashboard from "./pages/developer/DeveloperDashboard";
import DeveloperDashJob from "./pages/developer/DeveloperDashJob";
import DeveloperApplied from "./pages/developer/DeveloperApplied";
import DeveloperProfile from "./pages/developer/DeveloperProfile";
import EmployerDashboard from "./pages/employer/EmployerDashboard";
import EmployerBuild from "./pages/employer/EmployerBuild";
import EmployerProfile from "./pages/employer/EmployerProfile";
import EmployerRequests from "./pages/employer/EmployerRequests";
import EmployerBooking from "./pages/employer/EmployerBooking";
import AdminDash from "./pages/admin/AdminDash";
import AdminJobs from "./pages/admin/AdminJobs";
import AdminHires from "./pages/admin/AdminHires";
import AdminBuild from "./pages/admin/AdminBuild";
import AdminEmpList from "./pages/admin/AdminEmpList";
import AdminDevList from "./pages/admin/AdminDevList";
import BlogHome from "./pages/blog/BlogHome";
import BlogItem from "./pages/blog/BlogItem";
import EmployerJob from "./pages/job/EmployerJob";
import DeveloperJob from "./pages/job/DeveloperJob";
import AdminJobDetails from "./pages/job/AdminJobDetails";
import EmployerJobEdit from "./pages/job/EmployerJobEdit";
import AdminJobEdit from "./pages/job/AdminJobEdit";
import "./styles/App.css";
import "antd/dist/antd.css";

import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

function App() {
  const [resizeMenu, setResizeMenu] = useState(false);

  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/about" component={About} exact/>
          <Route path="/contact" component={Contact} exact/>
          <Route path="/terms" component={Terms} exact />
          <Route path="/privacy" component={Policy} exact />
          <Route path="/service/:service" component={HireServices} />
          <Route path="/hire/:id" component={HireSkills} />
          <Route
            path="/developer/:country/:skill"
            component={HireCountry}
            exact
          />
          <Route path="/employer/signup" component={EmployerSignUp} />
          <Route path="/employer/request" component={EmployerDetailsRequest} />
          <Route path="/developer/signup" component={DeveloperSignUp} />
          <Route
            path="/developer/request"
            component={DeveloperDetailsRequest}
          />
          <Route path="/login" component={Login} />
          <Route path="/forgotpassword" component={ForgotPassword} />
          <Route path="/reset/:token" component={ResetPassword} />
          <Route
            path="/developer/dashboard"
            render={(props) => (
              <DeveloperDashboard
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
            exact
          />
          <Route
            path="/developer/jobs"
            render={(props) => (
              <DeveloperDashJob
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
            exact
          />
          <Route
            path="/developer/applications"
            render={(props) => (
              <DeveloperApplied
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
            exact
          />
          <Route
            path="/developer/profile"
            render={(props) => (
              <DeveloperProfile
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
            exact
          />
          <Route
            path="/employer/dashboard"
            render={(props) => (
              <EmployerDashboard
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
            exact
          />
          <Route
            path="/employer/build"
            render={(props) => (
              <EmployerBuild
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/employer/profile"
            render={(props) => (
              <EmployerProfile
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/employer/requests"
            render={(props) => (
              <EmployerRequests
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route path="/employer/booking" component={EmployerBooking} />
          <Route
            path="/admin/dashboard"
            exact
            render={(props) => (
              <AdminDash
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/admin/build"
            render={(props) => (
              <AdminBuild
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/admin/jobs"
            exact
            render={(props) => (
              <AdminJobs
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/admin/hires"
            exact
            render={(props) => (
              <AdminHires
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/admin/employers"
            exact
            render={(props) => (
              <AdminEmpList
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/admin/developers"
            exact
            render={(props) => (
              <AdminDevList
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route path="/blog" component={BlogHome} exact />
          <Route path="/blog/:id" component={BlogItem} />

          <Route
            path="/employer/job/:id"
            exact
            render={(props) => (
              <EmployerJob
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/developer/dashboard/job/:id"
            render={(props) => (
              <DeveloperJob
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
            exact
          />
          <Route
            path="/admin/job/:id"
            exact
            render={(props) => (
              <AdminJobDetails
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/employer/job/edit/:id"
            exact
            render={(props) => (
              <EmployerJobEdit
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route
            path="/admin/job/edit/:id"
            exact
            render={(props) => (
              <AdminJobEdit
                {...props}
                resizeMenu={resizeMenu}
                setResizeMenu={setResizeMenu}
              />
            )}
          />
          <Route component={NotFound} />
        </Switch>
      </ScrollToTop>
    </Router>
  );
}

export default App;
